import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, AlertX, ColorX, GFunc, GState, IconX, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XImage, XScroll, XText } from "IZOX/_X";
import Styles from "__SYSDefault/Styles";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFText, QFPassword, QFDigitBox, QFCheckBox } from "IZOX/BLOCKS/Libs/QForm/_gears";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import ZValidate from "IZOX/STATIC/ZValidate";
import _ from "lodash";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import CountDownLite from "IZOX/BLOCKS/Libs/RefreshTimeCount/CountDownLite";
import HTMLReactParser from "html-react-parser";
import Password from "shared/Password";
import FooterM from "shared/FooterM";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PRegister extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      epFormValid: false,
      canResend: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetInfo();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PRegister.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountCountDown = (callbacks) => {
    this.MountCountDown = callbacks;
  }

  onMountQFEmailPassword = (callbacks) => {
    this.MountQFEmailPassword = callbacks;
  }

  onMountQFOTP = (callbacks) => {
    this.MountQFOTP = callbacks;
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info
    });
  }

  _updateFormData = (formValue) => {
    let formData = GState.GET("registerFormData");
    let newFormData = {
     ...formData,
     ...formValue
    };
    GState.UPDATE("registerFormData", newFormData);
    return newFormData;
  }

  _canResend = () => {
    this.setState({
      canResend: true
    });
  }

  _resendOTP = async () => {
    let formValue = GState.GET("registerFormData");
    let userID = Accessor.Get(formValue, "userID");
    let res = await APIExpress.OTP.Resend(userID, "Register");
    let {Success, payload} = res;
    if(!Success){
      return;
    }

    this.MountCountDown?.Reset?.();
    this.setState({
      canResend: false
    });
    
    let {requestID} = payload;
    this._updateFormData({
      requestID: requestID
    });
  }

  _autoVerifyOTP = async (otp) => {
    let formValue = GState.GET("registerFormData");
    let userID = Accessor.Get(formValue, "userID");
    let password = Accessor.Get(formValue, "password");
    let requestID = Accessor.Get(formValue, "requestID");

    let res = await APIExpress.OTP.Verify(userID, requestID, "Register", otp);
    let {Success} = res;

    if(Success){
      let authCode = res.payload;
      let verRes = await APIExpress.AuthCode.VerifyRegister(authCode, userID, password);
      if(verRes.Success){
        let logged = GFunc.Login(verRes.payload);
        if(logged.Success){
          this._toStep("ThankYou");
        }
        
      }else{
        AlertX.TryAgainLater();
        this.MountQFOTP?.Clear?.();
      }
    }else{
      AlertX.TryAgainLater();
      this.MountQFOTP?.Clear?.();
    }
  }

  _apply = async () => {
    let formValue = GState.GET("registerFormData");
    let {Success, error} = this._checkEPFormValid(formValue);
    if(error) GFunc.Alert(error, "error");
    if(!Success) return;
    let res = await APIExpress.Register.Reigster(formValue);
    if(!res.Success){
      return;
    }
    let {userID, requestID} = res.payload;
    this._updateFormData({
      userID: userID,
      requestID: requestID
    });
    this._toStep("OTP");
  }

  _checkEPFormValid = (formValue) => {
    let email = Accessor.Get(formValue, "email");
    
    if(!ZValidate.Check(email, ["required", "email"])){
      return {
        Success: false,
        error: {
          EN: "Email format invalid.",
          TC: "電子郵件格式無效"
        }
      };
    }

    let errors = Password.CheckIfErrors(formValue, "password");

    if(!_.isEmpty(errors)){
      let msgEN = _.map(errors, o => LocaleX.Parse(o, undefined, "EN")).join("\n");
      let msgTC = _.map(errors, o => LocaleX.Parse(o, undefined, "TC")).join("\n");
      return {
        Success: false,
        error: {
          EN: "Password must be:\n" + msgEN,
          TC: "密碼必需為:\n" + msgTC
        }
      };
    }

    let valid = ZValidate.CheckAllFields(formValue, 
      ["password", "confirmPassword", "email", "userType"],
      "required"
    );

    if(!valid){
      return {
        Success: false,
        error: {
          EN: "Some fields are empty.",
          TC: "有些欄位沒有填妥"
        }
      };
    }

    if(!Accessor.IsAllFieldIdentical(formValue, ["password", "confirmPassword"])){
      return {
        Success: false,
        error: {
          EN: "Password not match.",
          TC: "密碼不匹配"
        }
      };
    }
    
    if(Accessor.Get(formValue, "privacy") !== true) {
      return {
        Success: false,
        error: {
          EN: "Please check to agree the Privacy Policy Statement to continue",
          TC: "請勾選方格同意私隱政策聲明以繼續"
        }
      };
    }

    return {
      Success: true
    };
  }

  _toStep = (step) => {
    GState.UPDATE("registerStep", step);
  }

  _setUserType = (userType) => {
    this._updateFormData({userType: userType});
  }

  _toLogin = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Login");
  }

  _toRedirect = () => {
    let {history} = this.props;
    NavX.Goto(history, "/User/Redirect");
  }

  _toPopupTandC = () => {
    let {info} = this.state;
    let {tandc} = info ?? {};
    let {page} = tandc ?? {};
    let _doc = _.find(page, o => o?.title?.EN?.includes?.("Privacy"));
    let {title, content} = _doc ?? {};
    GFunc.Backdrop(() => {
      return (
        <VStack bgColor={ColorX.CSS("pureWhite")}
          width={705} maxHeight={window.innerHeight * 0.9}>
          <HStack pH={16} shadow>
            <XText fontSize={16} bold fontFamily="Noto Sans SC">
              {LocaleX.Parse(title)}
            </XText>
            <Spacer/>
            <XIconButton onPress={() => GFunc.CloseBackdrop()}>
              {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
            </XIconButton>
          </HStack>
          <XScroll p={16} fullWidth style={{maxHeight: window.innerHeight * 0.7}}>
            <XText textAlign="[" fullWidth>
              {HTMLReactParser(LocaleX.Parse(content))}
            </XText>
          </XScroll>
        </VStack>
      );
    }, {}, false, false);
  }

  renderUserTypeButton(userType, caption, content, onImg, offImg){
    let _formValue = GState.GET("registerFormData");
    let _userType = Accessor.Get(_formValue, "userType");
    let isType = userType === _userType;

    let _size = Math.min(240, window.innerWidth * 0.4);

    return (
      <XButton onPress={() => this._setUserType(userType)}
        width={_size} height={_size} round={15} m={10} notInjectColor
        style={{
          background: isType ? ColorX.GetLinearGradient("userTypeGrass") : ColorX.CSS("Gray5"),
          backgroundColor: undefined,
          boxShadow: "0px 5px 5px 5px " + ColorX.CSS("greyOut", 0.3)
        }}>
        <VStack spacing={10} fullWidth fullHeight VAlign="-">
          <XImage source={isType? onImg: offImg}/>
          <XText fontSize={16} bold color={ColorX.CSS(isType ? "Leaf" : "Gray3")} textAlign="|">
            {LocaleX.Parse(caption)}
          </XText>
          {/* <XText fontSize={14} textAlign="|" >
            {LocaleX.Parse(content)}
          </XText> */}
        </VStack>
      </XButton>
    );
  }

  renderUserType(){
    return (
      <VStack fullHeight VAlign="-" spacing={24}>
        <VStack>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Select User Type",
              TC: "選擇用戶種類"
            })}
          </XText>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "You can change your account at anytime.",
              TC: "您可以隨時變更您的帳戶。"
            })}
          </XText>
        </VStack>
        <HStack spacing={24}>
          {this.renderUserTypeButton("Agent", 
            {
              EN: "Agency",
              TC: "代理"
            },
            // {
            //   EN: "Lorem ipsum dolor sit amet consectetur malesuada.",
            //   TC: "Lorem ipsum dolor sit amet consectetur malesuada."
            // },
            null,
            "Images/home/agency_on.png", 
            "Images/home/agency_off.png")}
          {this.renderUserTypeButton("DCustomer", 
            {
              EN: "Direct Customer",
              TC: "直接客戶"
            },
            // {
            //   EN: "Lorem ipsum dolor sit amet consectetur malesuada.",
            //   TC: "Lorem ipsum dolor sit amet consectetur malesuada."
            // },
            null,
            "Images/home/dc_on.png", 
            "Images/home/dc_off.png")}
        </HStack>
        <XButton {...Styles.QFBtn} width={200}
          onPress={() => this._toStep("emailPassword")}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Next",
                TC: "下一步"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderEmailPassword(){
    let {epFormValid, error} = this.state;
    return (
      <QForm maxWidth={"80%"} width={416} fullHeight VAlign="^" pT={30} 
        spacing={16} onMounted={this.onMountQFEmailPassword}
        onChange={(formValue) => {
          let _new = this._updateFormData(formValue);
          let {Success, error} = this._checkEPFormValid(_new);
          this.setState({
            epFormValid: Success,
            error: error
          });
        }}>
        <XImage source="/Images/home/logoV.png"/>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Register",
            TC: "登記"
          })}
        </XText>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Email",
                TC: "電郵"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFText
            name="email"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your email here.",
              TC: "請在此輸入您的電子郵件。",
            })}
            />
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Create Password",
                TC: "建立密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="password"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your password here.",
              TC: "請在此輸入您的密碼。",
            })}
            />
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Confirm Password",
                TC: "確認密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="confirmPassword"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your password here.",
              TC: "請在此輸入您的密碼。",
            })}
            />
        </VStack>
        <HStack spacing={10}>
          <QFCheckBox bColor={ColorX.CSS("pureWhite")} 
            bgColor={ColorX.CSS("Grass")}
            color={ColorX.CSS("Axit")}
            name="privacy"/>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12}>
              {LocaleX.Parse({
                EN: "I have read and agree to the ",
                TC: "我已閱讀並同意"
              })}
            </XText>
            <XButton padding={0} color={ColorX.CSS("DeepBlueSea")} onPress={this._toPopupTandC}>
              <XText fontSize={12} 
                style={{
                  textDecoration: "underline"
                }}>
                {LocaleX.Parse({
                  EN: "Terms Conditions & Privacy Policy",
                  TC: "條款條件和隱私權政策"
                })}
              </XText>
            </XButton>
          </HStack>
        </HStack>
        <XButton {...Styles.QFBtn} fullWidth
          onPress={this._apply} disabled={!epFormValid}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Create an account",
                TC: "建立帳戶"
              })}
            </XText>
          </HStack>
        </XButton>
        {!_.isEmpty(error)
          && 
          <XText color={ColorX.CSS("Blood")} fontSize={12} textAlign="[" fullWidth newLine>
            {"*" + LocaleX.Parse(error)}
          </XText>
        }
      </QForm>
    );
  }

  renderOTP(){
    let {canResend} = this.state;
    return (
      <QForm spacing={24} fullHeight VAlign="-" pB={120} onMounted={this.onMountQFOTP}>
        <VStack>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold textAlign="|">
            {LocaleX.Parse({
              EN: "Verify Your Account",
              TC: "驗證您的帳戶"
            })}
          </XText>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")} textAlign="|">
            {LocaleX.Parse({
              EN: "Enter the 6-digit verification code sent to your registered email address",
              TC: "輸入發送到您註冊電子郵件地址的 6 位驗證碼"
            })}
          </XText>
        </VStack>
        <QFDigitBox onDigitEnd={this._autoVerifyOTP} 
          digit={6} name="otp"
          color={ColorX.CSS("Stone")}
          fontSize={30}
          p={12}
          bColor={ColorX.CSS("NotQuiteWhite")}/>
        <VStack>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "Didn't receive one-time code?",
              TC: "沒有收到一次性代碼？"
            })}
          </XText>
          <XButton onPress={this._resendOTP} disabled={!canResend}>
            <HStack>
              <XText color={ColorX.CSS("DeepBlueSea")} fontSize={16} bold>
                {LocaleX.Parse({
                  EN: "Resend",
                  TC: "重發"
                })}
              </XText>
              {!canResend && 
                <HStack fitWidthToContent>
                  <XText>{"("}</XText>
                  <CountDownLite onMounted={this.onMountCountDown}
                    countDown={60} onTimeUp={this._canResend}/>
                  <XText>{")"}</XText>
                </HStack>}
            </HStack>
          </XButton>
        </VStack>
      </QForm>
    );
  }

  renderThankYou(){
    return (
      <VStack fullHeight fullWidth VAlign="-" spacing={24}>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Thank You",
            TC: "多謝"
          })}
        </XText>
        <XText fontSize={14} color={ColorX.CSS("pureWhite")} textAlign="|">
          {LocaleX.Parse({
            EN: "Thank you for your registration.\nYou can now login to the system and fill the necessary information for completing the registration.\nWe will follow your application and finish setting up your account as soon as possible.\nThank you for taking the time to confirm the details, it's greatly appreciated.",
            TC: "感謝您的註冊。\n現在您可以登入系統並填寫必要的資訊以完成註冊。\n我們將跟進您的申請並儘快完成您的帳戶設定。\n感謝您花時間確認詳細信息，非常感謝。"
          })}
        </XText> 
        <XButton {...Styles.QFBtn} width={200} onPress={this._toRedirect}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Fill your profile",
                TC: "填寫你的個人資料"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderStep(){
    let _step = GState.GET("registerStep");
    switch(_step){
      default: case "userType": return this.renderUserType();
      case "emailPassword": return this.renderEmailPassword();
      case "OTP": return this.renderOTP();
      case "ThankYou": return this.renderThankYou();
    }
  }

  render(){
    return (
      <VStack flexGrow={1} bgColor={ColorX.CSS("Grass")} fullWidth fullHeight>
        <XImage source="/Images/static/pattern.png" noResize height={"auto"} maxWidth={"50%"}
          position="absolute" style={{bottom: 0, right: 0}}/>
        {this.renderStep()}
        {ResponsiveX.Split({0: () => <FooterM/>, [SysConfig.WebUIWidth]: () => null})}
      </VStack>
    );
  }

}

export default withRouter(observer(PRegister));
